import { PickupAvailability } from '@/scripts/optional/pickup-availability'
import { PickupAvailabilityDrawer } from '@/scripts/optional/pickup-availability-drawer'
import { safeDefineElement } from '@/scripts/core/global'
safeDefineElement(PickupAvailabilityDrawer)
safeDefineElement(PickupAvailability)

